import { render } from "./right-sidebar.vue?vue&type=template&id=b2f5fbbe&scoped=true"
import script from "./right-sidebar.vue?vue&type=script&lang=js"
export * from "./right-sidebar.vue?vue&type=script&lang=js"

import "./right-sidebar.vue?vue&type=style&index=0&id=b2f5fbbe&scoped=true&lang=css"
import "./right-sidebar.vue?vue&type=style&index=1&id=b2f5fbbe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f5fbbe"]])

export default __exports__